(function () {
  function initWidget(widget) {
    const form = widget.closest('form');
    if (!form) return;

    const variant30 = widget.getAttribute('data-variant-30');
    const variant60 = widget.getAttribute('data-variant-60');
    const planSingle = widget.getAttribute('data-selling-plan-single') || '';
    const planDouble = widget.getAttribute('data-selling-plan-double') || '';

    const idInput = form.querySelector('input[name="id"]');
    const planInputs = form.querySelectorAll('input[name="selling_plan_id"]'); // pak ook eventuele dubbele
    const radios = widget.querySelectorAll('input[type="radio"][name="fh_purchase"]');

    function setValues(choice) {
      let v = variant30;
      let p = '';

      if (choice === 'single_sub') { v = variant30; p = planSingle; }
      if (choice === 'double_sub') { v = variant60; p = planDouble; }
      if (choice === 'onetime')    { v = variant30; p = ''; }

      if (idInput) {
        idInput.value = v;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      planInputs.forEach(inp => {
        inp.value = p;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // active class voor design
      widget.querySelectorAll('.fh-card').forEach(card => card.classList.remove('fh-card--active'));
      const activeCard = widget.querySelector(`.fh-card[data-fh-choice="${choice}"]`);
      if (activeCard) activeCard.classList.add('fh-card--active');
    }

    radios.forEach(r => {
      r.addEventListener('change', () => setValues(r.value));
    });

    // default (kies wat jij wilt)
    const defaultChoice = 'single_sub'; // of 'onetime'
    const defaultRadio = widget.querySelector(`input[name="fh_purchase"][value="${defaultChoice}"]`);
    if (defaultRadio) defaultRadio.checked = true;
    setValues(defaultChoice);
  }

  function boot() {
    document.querySelectorAll('.fh-widget').forEach(initWidget);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
